
export interface displaySettings {
      displayPrice: boolean;
      showAddToCart: boolean;
      ShowCallForAvailability: boolean;
    }

const availabilityDictionaryByStatus: { [key: string]: displaySettings } = {
  'ADD_TO_CART': {displayPrice:true, showAddToCart:true, ShowCallForAvailability:false},
  'NOT_AVAILABLE': {displayPrice:true, showAddToCart:false, ShowCallForAvailability:true},
  'DISCONTINUED':{displayPrice:false, showAddToCart:false, ShowCallForAvailability:true},
  'NOT_AVAILABLE_IN_SITE':{displayPrice:false, showAddToCart:false, ShowCallForAvailability:true},
  'DOWNLOAD':{displayPrice:false, showAddToCart:false, ShowCallForAvailability:false},
  'NOT_FOUND':{displayPrice:false, showAddToCart:false, ShowCallForAvailability:false},
};


export {availabilityDictionaryByStatus};